import React from 'react';

const Eat = ({ body }) => (
	<div className="main-content-body-inner-container main-content-body-eat">
		<div className="main-content-body-title">
          EAT
        </div>
		<div className="main-content-text-container main-content-body-scrollable-box">
			{body ? (
				<div
					className="body-html-box"
					dangerouslySetInnerHTML={{ __html: body }}
				/>
			) : null}
		</div>
	</div>
);

export default Eat;



// WEBPACK FOOTER //
// ./src/Theme/Eat.jsx